export var ShowProgressBar;
(function (ShowProgressBar) {
    ShowProgressBar["AUTO"] = "auto";
    ShowProgressBar["BOTTOM"] = "bottom";
    ShowProgressBar["ABOVEHEADER"] = "aboveheader";
    ShowProgressBar["BELOWHEADER"] = "belowheader";
    ShowProgressBar["TOPBOTTOM"] = "topbottom";
})(ShowProgressBar || (ShowProgressBar = {}));
export var ShowNavigationButtons;
(function (ShowNavigationButtons) {
    ShowNavigationButtons["TOP"] = "top";
    ShowNavigationButtons["BOTTOM"] = "bottom";
    ShowNavigationButtons["BOTH"] = "both";
})(ShowNavigationButtons || (ShowNavigationButtons = {}));
export var CellType;
(function (CellType) {
    CellType["CHECKBOX"] = "checkbox";
    CellType["RADIOGROUP"] = "radiogroup";
    CellType["TAGBOX"] = "tagbox";
    CellType["TEXT"] = "text";
    CellType["COMMENT"] = "comment";
    CellType["BOOLEAN"] = "boolean";
    CellType["RATING"] = "rating";
    CellType["EXPRESSION"] = "expression";
    CellType["DEFAULT"] = "default";
})(CellType || (CellType = {}));
export var MatrixColumnTotalType;
(function (MatrixColumnTotalType) {
    MatrixColumnTotalType["SUM"] = "sum";
    MatrixColumnTotalType["COUNT"] = "count";
    MatrixColumnTotalType["MIN"] = "min";
    MatrixColumnTotalType["MAX"] = "max";
    MatrixColumnTotalType["AVG"] = "avg";
})(MatrixColumnTotalType || (MatrixColumnTotalType = {}));
export var MatrixColumnTotalDisplayStyle;
(function (MatrixColumnTotalDisplayStyle) {
    MatrixColumnTotalDisplayStyle["DECIMAL"] = "decimal";
    MatrixColumnTotalDisplayStyle["CURRENCY"] = "currency";
    MatrixColumnTotalDisplayStyle["PERCENT"] = "percent";
})(MatrixColumnTotalDisplayStyle || (MatrixColumnTotalDisplayStyle = {}));
export var ChoicesOrder;
(function (ChoicesOrder) {
    ChoicesOrder["ASC"] = "asc";
    ChoicesOrder["DESC"] = "desc";
    ChoicesOrder["RANDOM"] = "random";
})(ChoicesOrder || (ChoicesOrder = {}));
export var ProgressBarType;
(function (ProgressBarType) {
    ProgressBarType["QUESTIONS"] = "questions";
    ProgressBarType["REQUIRED_QUESTIONS"] = "requiredQuestions";
    ProgressBarType["CORRECT_ANSWERS"] = "correctQuestions";
})(ProgressBarType || (ProgressBarType = {}));
export var ShowQuestionNumbers;
(function (ShowQuestionNumbers) {
    ShowQuestionNumbers["ON_PAGE"] = "onPage";
    ShowQuestionNumbers["OFF"] = "off";
})(ShowQuestionNumbers || (ShowQuestionNumbers = {}));
export var ShowPreviewBeforeComplete;
(function (ShowPreviewBeforeComplete) {
    ShowPreviewBeforeComplete["NO_PREVIEW"] = "noPreview";
    ShowPreviewBeforeComplete["SHOW_ALL_QUESTIONS"] = "showAllQuestions";
    ShowPreviewBeforeComplete["SHOW_ANSWERED_QUESTIONS"] = "showAnsweredQuestions";
})(ShowPreviewBeforeComplete || (ShowPreviewBeforeComplete = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["SET_VALUE"] = "setvalue";
    TriggerType["COMPLETE"] = "complete";
    TriggerType["SKIP"] = "skip";
    TriggerType["RUN_EXPRESSION"] = "runexpression";
    TriggerType["COPY_VALUE"] = "copyvalue";
})(TriggerType || (TriggerType = {}));
export var SurveyElementTypeEnum;
(function (SurveyElementTypeEnum) {
    SurveyElementTypeEnum["TEXT"] = "text";
    SurveyElementTypeEnum["COMMENT"] = "comment";
    SurveyElementTypeEnum["DROPDOWN"] = "dropdown";
    SurveyElementTypeEnum["RADIOGROUP"] = "radiogroup";
    SurveyElementTypeEnum["CHECKBOX"] = "checkbox";
    SurveyElementTypeEnum["BOOLEAN"] = "boolean";
    SurveyElementTypeEnum["FILE"] = "file";
    SurveyElementTypeEnum["IMAGEPICKER"] = "imagepicker";
    SurveyElementTypeEnum["RATING"] = "rating";
    SurveyElementTypeEnum["RANKING"] = "ranking";
    SurveyElementTypeEnum["MATRIX"] = "matrix";
    SurveyElementTypeEnum["MATRIXDROPDOWN"] = "matrixdropdown";
    SurveyElementTypeEnum["MATRIXDYNAMIC"] = "matrixdynamic";
    SurveyElementTypeEnum["MULTIPLETEXT"] = "multipletext";
    SurveyElementTypeEnum["TAGBOX"] = "tagbox";
    SurveyElementTypeEnum["PANEL"] = "panel";
    SurveyElementTypeEnum["SIGNATUREPAD"] = "signaturepad";
    SurveyElementTypeEnum["IMAGE"] = "image";
    SurveyElementTypeEnum["HTML"] = "html";
    SurveyElementTypeEnum["EXPRESSION"] = "expression";
})(SurveyElementTypeEnum || (SurveyElementTypeEnum = {}));
export var SurveyInputTypeEnum;
(function (SurveyInputTypeEnum) {
    SurveyInputTypeEnum["TEXT"] = "text";
    SurveyInputTypeEnum["COLOR"] = "color";
    SurveyInputTypeEnum["DATE"] = "date";
    SurveyInputTypeEnum["DATETIME_LOCAL"] = "datetime-local";
    SurveyInputTypeEnum["EMAIL"] = "email";
    SurveyInputTypeEnum["MONTH"] = "month";
    SurveyInputTypeEnum["NUMBER"] = "number";
    SurveyInputTypeEnum["PASSWORD"] = "password";
    SurveyInputTypeEnum["RANGE"] = "range";
    SurveyInputTypeEnum["TEL"] = "tel";
    SurveyInputTypeEnum["TIME"] = "time";
    SurveyInputTypeEnum["URL"] = "url";
    SurveyInputTypeEnum["WEEK"] = "week";
})(SurveyInputTypeEnum || (SurveyInputTypeEnum = {}));
export var ExpressionDisplayStyle;
(function (ExpressionDisplayStyle) {
    ExpressionDisplayStyle["NONE"] = "none";
    ExpressionDisplayStyle["DECIMAL"] = "decimal";
    ExpressionDisplayStyle["CURRENCY"] = "currency";
    ExpressionDisplayStyle["PERCENT"] = "percent";
    ExpressionDisplayStyle["DATE"] = "date";
})(ExpressionDisplayStyle || (ExpressionDisplayStyle = {}));
export var VisibilityExpression = {
    EQUAL: "=",
    NOT_EQUAL: "<>",
    EQUAL_STRICT: "==",
    NOT_EQUAL_STRICT: "!=",
    GREATER_THAN: ">",
    LESS_THAN: "<",
    GREATER_THAN_OR_EQUAL: ">=",
    LESS_THAN_OR_EQUAL: "<=",
    CONTAINS: "contains",
    NOT_CONTAINS: "notcontains",
    ANY_OF: "anyof",
    ALL_OF: "allof",
    NOT_EMPTY: "notempty",
    EMPTY: "empty",
};
export var ValidatorType;
(function (ValidatorType) {
    ValidatorType["EXPRESSION"] = "expression";
    ValidatorType["NUMERIC"] = "numeric";
    ValidatorType["TEXT"] = "text";
    ValidatorType["REGEX"] = "regex";
    ValidatorType["EMAIL"] = "email";
    ValidatorType["ANSWER_COUNT"] = "answercount";
})(ValidatorType || (ValidatorType = {}));
export var MatrixConditionKeyEnum;
(function (MatrixConditionKeyEnum) {
    MatrixConditionKeyEnum["ENABLE_IF"] = "enableIf";
    MatrixConditionKeyEnum["REQUIRED_IF"] = "requiredIf";
    MatrixConditionKeyEnum["RESET_VALUE_IF"] = "resetValueIf";
    MatrixConditionKeyEnum["SET_VALUE_IF"] = "setValueIf";
})(MatrixConditionKeyEnum || (MatrixConditionKeyEnum = {}));
export var MaskType;
(function (MaskType) {
    MaskType["PATTERN"] = "pattern";
    MaskType["NUMERIC"] = "numeric";
    MaskType["CURRENCY"] = "currency";
    MaskType["DATETIME"] = "datetime";
})(MaskType || (MaskType = {}));
export var QuestionsOnPageMode;
(function (QuestionsOnPageMode) {
    QuestionsOnPageMode["STANDARD"] = "standard";
    QuestionsOnPageMode["SINGLE_PAGE"] = "singlePage";
    QuestionsOnPageMode["QUESTION_PER_PAGE"] = "questionPerPage";
})(QuestionsOnPageMode || (QuestionsOnPageMode = {}));
export var TextUpdateMode;
(function (TextUpdateMode) {
    TextUpdateMode["ON_BLUR"] = "onBlur";
    TextUpdateMode["ON_TYPING"] = "onTyping";
})(TextUpdateMode || (TextUpdateMode = {}));
export var NormalizedClearInvisibleValues;
(function (NormalizedClearInvisibleValues) {
    NormalizedClearInvisibleValues["NONE"] = "none";
    NormalizedClearInvisibleValues["ON_COMPLETE"] = "onComplete";
    NormalizedClearInvisibleValues["ON_HIDDEN"] = "onHidden";
    NormalizedClearInvisibleValues["ON_HIDDEN_CONTAINER"] = "onHiddenContainer";
})(NormalizedClearInvisibleValues || (NormalizedClearInvisibleValues = {}));
export var CheckErrorsMode;
(function (CheckErrorsMode) {
    CheckErrorsMode["ON_NEXT_PAGE"] = "onNextPage";
    CheckErrorsMode["ON_VALUE_CHANGED"] = "onValueChanged";
    CheckErrorsMode["ON_COMPLETE"] = "onComplete";
})(CheckErrorsMode || (CheckErrorsMode = {}));
